export const EDIT_FORM = 'EDIT_FORM'
export const CREATE_FORM = 'CREATE_FORM'
